import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { LambdaFunctionService } from '../../../service/lambda-function.service';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../../http.service';
import { Store } from "@ngrx/store";
import { RosterServiceService } from '../roster-service.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-download-team-graph',
  templateUrl: './download-team-graph.component.html',
  styleUrls: ['./download-team-graph.component.scss']
})
export class DownloadTeamGraphComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  // Inputs from parent (previously accessed via injector)
  @Input() slectedIndividualTeamArr: any[] = [];
  @Input() selectedGroupProfileTeamsArr: any[] = [];
  @Input() mockupReportArgs: any;
  @Input() mockupReportArgsArr: any[] = [];
  @Input() openPdfPopup: boolean = false;

  // Outputs to parent
  @Output() openPdfPopupChange = new EventEmitter<boolean>();
  @Output() mockupReportArgsChange = new EventEmitter<any>();
  @Output() downloadCsv = new EventEmitter<string>();

  team: any;
  clarifier_low:number = 0;
  clarifier_high:number = 0;
  ideator_low:number = 0;
  ideator_high:number = 0;
  developer_low:number = 0;
  developer_high:number = 0;
  implementor_low:number = 0;
  implementor_high:number = 0;
  clarifier_neutral:number = 0;
  ideator_neutral:number = 0;
  developer_neutral:number = 0;
  implementor_neutral:number =0;
  integrator:number = 0;
  highest_score:number = 0;
  total_members:number = 0;
  date;
  args:any;
  env = environment;
  currentTeamId;
  pdfLink;
  loadingMembers = false;
  loader = false;
  loader_text = 'Generating PDF';
  individualArgs:any;
  content_type;
  format = "letter";
  groupProfileType:any;
  teamProfileType:any;
  downloadMode: 'individual' | 'group' | 'teamReport' | null = null;
  csvFormat: 'flat' | 'grouped' | null = null;
  individualProfileArgsArr:any = [];
  ngrxAccessGroup:any;
  accessGroup:any;
  teamMemberCount: number = 0;

  constructor( public store: Store<any>,private lmbda_service: LambdaFunctionService, private httpService: HttpService, private http: HttpClient, public rosterService: RosterServiceService) {
  }

  ngOnInit() {
    this.date = new Date();
    this.ngrxAccessGroup = this.store.select<any>((state) => state.profile.accessGroupData);
     this.ngrxAccessGroup.pipe(takeUntil(this.destroy$)).subscribe((message) => {
      if (message && Object.keys(message).length) {
        this.accessGroup = message;
      }
    })
  }

    public async setGraphData(currentTeam) {
    this.total_members = currentTeam.memberships_count;
    currentTeam?.memberships?.forEach(list => {
        if(list?.default_profile){
            if(list?.default_profile?.clarifier_score == 'Low'){
                this.clarifier_low = this.clarifier_low + 1;
                if( this.clarifier_low > this.highest_score ){
                    this.highest_score = this.clarifier_low;
                }
            }
  
            if(list?.default_profile?.clarifier_score == 'High'){
                this.clarifier_high = this.clarifier_high + 1;
                if( this.clarifier_high > this.highest_score ){
                    this.highest_score = this.clarifier_high;
                }
            }
  
            if(list?.default_profile.ideator_score == 'Low'){
                this.ideator_low = this.ideator_low + 1;
                if( this.ideator_low > this.highest_score ){
                    this.highest_score = this.ideator_low;
                }
            }
  
            if(list?.default_profile?.ideator_score == 'High'){
                this.ideator_high = this.ideator_high + 1;
                if( this.ideator_high > this.highest_score ){
                    this.highest_score = this.ideator_high;
                }
            }
  
            if(list?.default_profile.developer_score == 'Low'){
                this.developer_low = this.developer_low + 1;
                if( this.developer_low > this.highest_score ){
                    this.highest_score = this.developer_low;
                }
            }
  
            if(list?.default_profile?.developer_score == 'High'){
                this.developer_high = this.developer_high + 1;
                if( this.developer_high > this.highest_score ){
                    this.highest_score = this.developer_high;
                }
            }
  
            if(list?.default_profile?.implementer_score == 'Low'){
                this.implementor_low = this.implementor_low + 1;
                if( this.implementor_low > this.highest_score ){
                    this.highest_score = this.implementor_low;
                }
            }
  
            if(list?.default_profile?.implementer_score == 'High'){
                this.implementor_high = this.implementor_high + 1;
                if( this.implementor_high > this.highest_score ){
                    this.highest_score = this.implementor_high;
                }
            }
  
            //   neutral profiles
            if(list?.default_profile?.clarifier_score == 'Neutral') {
              this.clarifier_neutral += 1; 
            }
            if(list.default_profile.ideator_score == 'Neutral') {
              this.ideator_neutral += 1; 
            }
            if(list.default_profile.developer_score == 'Neutral') {
              this.developer_neutral += 1; 
            }
            if(list.default_profile.implementer_score == 'Neutral') {
              this.implementor_neutral += 1; 
            }
            if(list?.default_profile?.clarifier_score == 'Neutral' && list.default_profile.ideator_score == 'Neutral' && list.default_profile.developer_score == 'Neutral' && list.default_profile.implementer_score == 'Neutral'){
              this.integrator += 1;
              }
  
        }
  
    });
    $('.graph-loader').css('display','none')
    await this.setArgs()
  }

   public setArgs() {
    let name = this.team.name;
    let membershipcount = this.team.memberships_count;
    let org_id = this.team.organization_id;
    let org_name = this.team.organization_name;
    let date = String(this.date.getFullYear()) + String((this.date.getMonth() + 1)) + String(this.date.getDate());
    let time = String(this.date.getHours()) + String(this.date.getMinutes());
    this.args = {
      "function_name": "plus-GroupProfileFunction-6y5p4TgXuqZA",
      "invocation_type": "RequestResponse",
      "log_type": "None",
      "template": "team_pf.html",
      "filename": org_name+ '-' + date + time,
      "memberships_count": membershipcount,
      "name": name,
      "organization_title": "Organization",
      "organization_id": org_id,
      "organization_name": org_name,
      "clarifier_low": this.clarifier_low ? this.clarifier_low : 0,
      "clarifier_neutral": this.clarifier_neutral ? this.clarifier_neutral : 0,
      "clarifier_high": this.clarifier_high ? this.clarifier_high : 0,
      "ideator_low": this.ideator_low ? this.ideator_low : 0,
      "ideator_neutral": this.ideator_neutral ? this.ideator_neutral : 0,
      "ideator_high": this.ideator_high ?  this.ideator_high : 0,
      "developer_low": this.developer_low ? this.developer_low : 0,
      "developer_neutral": this.developer_neutral ? this.developer_neutral : 0,
      "developer_high": this.developer_high ? this.developer_high : 0,
      "implementor_low": this.implementor_low ? this.implementor_low : 0,
      "implementor_neutral": this.implementor_neutral ? this.implementor_neutral : 0,
      "implementor_high": this.implementor_high ? this.implementor_high : 0,
      "integrator": this.integrator ?  this.integrator : 0,
      "highest_score": this.highest_score ? this.highest_score : 0,
      "app_type": "Group Profile Plus",
      "pdf_type": "letter",
      "email": "sarah@blairmiller.com",
      "content_type": 'pdf',
      "profile_type": "Ask",
      "description": "Look at your graph. What do you notice? What, if anything, is surprising? Where does this group need to pay deliberate attention so they can succeed? Think of a project or a challenge this group has recently been engaged in. Describe how the group approached the project using the group profile as a guide.",
      "footer_imptext": "FourSight® Group Profile",
      "footer_text": "provides a snapshot of how a group's energy will likely rise and fall as people work together through the four stages of the universal problem solving process. The numbers indicate how many individuals in the group have a high, neutral, or low thinking preference for each stage.",
      "remember": "Preference <span>=</span> Energy",
      "team_des": "FourSight is a measure of thinking preference, not ability. A preference is a measure of energy, not talent. People with a high preference tend to gravitate to that stage of the problem-solving process. People with a low preference tend to move quickly through it. People with a neutral preference tend to do the work and move on. All three approaches can lead to problem-solving success. Teams are more likely to succeed when people are both self-aware and process aware.",
      "footer_des": null,
    }
  }

  public SelectDownloadType(type, format='letter') {
    this.individualProfileArgsArr = [];
    this.content_type = type;
    this.format = format
    this.pdfLink = ''
    this.slectedIndividualTeamArr.forEach(async (el) => {
      this.createArgsAndDownload(el);
    })
  }

  public createArgsAndDownload(item) {
    this.loader = true;
    this.individualArgs = {
      "content_type": this.content_type,
      "filename": "foursight-roster"+ item.id + '-profile' + new Date().getTime(),
      "format": this.format,
      "members": [],
      "organization": "organization",
      "template": "multi-profile.html"
    }
    if(this.slectedIndividualTeamArr.length == 1) {
     this.individualArgs['downloadAble'] = true
    }
    const sortedMemberships = [...(item?.memberships || [])].sort((a, b) => {
      const aName = (a?.default_profile?.first_name || a?.first_name || '').toLowerCase();
      const bName = (b?.default_profile?.first_name || b?.first_name || '').toLowerCase();
      return aName < bName ? -1 : aName > bName ? 1 : 0;
    });
    sortedMemberships.forEach((team) => {
      if(team.default_profile) {
        team['default_profile']['thinking_profile_heading'] = 'FourSight<sup>®</sup> Thinking Profile</span>';
        team['default_profile']['thinking_profile_message'] = 'measures where you gain energy in the innovation process. There are no "good" or "bad" scores. Each of these four preferences has its own strengths and potential weaknesses. The goal is not to change your preferences, but to understand how your preferences are affecting your decision making, your perceptions, your stress levels and your interactions with others.';
        team['default_profile']['organization_title'] = 'Organization';
        team['default_profile']['organization'] = 'Organization';
        team['default_profile']['low_preference'] = 'Low Preference';
        team['default_profile']['high_preference'] = 'High Preference';
        team['default_profile']['contrast'] = 'Neutral';
        team['default_profile']['clarify'] = 'Clarify';
        team['default_profile']['ideate'] = 'Ideate';
        team['default_profile']['develop'] = 'Develop';
        team['default_profile']['implement'] = 'Implement';
        team['default_profile']['prefers_to'] = 'prefers to';
        team['default_profile']['get_report'] = 'Get your full report at';
        team['default_profile']['sign_up_with'] = 'Sign up with the email';
        this.individualArgs["members"].push(team.default_profile)
      }
    })
    this.individualProfileArgsArr.push(this.individualArgs)
    this.loader = false;
  }

  public DownloadThinkingProfile() {
    let pdfUrls = [];
    this.loader = true;
    this.loader_text = "Generating PDF";
    this.individualProfileArgsArr.forEach(async (el) => {
      this.lmbda_service.lambda_invoke('thinking-ProfileFunction-pxVk1VnOrZ3r',el)
      this.lmbda_service.lambda_res.pipe(takeUntil(this.destroy$)).subscribe((output)=> {
        if(this.individualProfileArgsArr.length == 1) {
          this.pdfLink = output;
          if(output.length) {
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          }
        } else {
          if(output.length && !pdfUrls.includes(output)) {
            pdfUrls.push(output);
            this.pdfLink = output;
            setTimeout(() => {
                this.loader = false;
              }, 1000);
          }
        }
      })
    })
  }

  public fetchMembers() {
    const teamsNeedingFetch = this.slectedIndividualTeamArr?.filter(
      (el) => el.memberships_count > 20 && el.memberships?.length !== el.memberships_count
    ) || [];

    if (!teamsNeedingFetch.length) {
      this.loadingMembers = false;
      return;
    }

    this.loadingMembers = true;
    this.loader_text = 'Loading team members...';
    let completed = 0;

    teamsNeedingFetch.forEach((el) => {
      let allTeamMem: any = this.httpService.getRequest(
        `${environment.profileURL}/api/v1/teams/${el.id}/memberships.json?name_order=asc&per_page=${el.memberships_count}`
      );
      allTeamMem.pipe(takeUntil(this.destroy$)).subscribe((res) => {
        el.memberships = res.memberships;

        // Recompute group profile stats for this team from full memberships
        const groupIdx = this.selectedGroupProfileTeamsArr.findIndex(g => g.id === el.id);
        if (groupIdx !== -1) {
          this.recomputeGroupProfileArgs(el, this.selectedGroupProfileTeamsArr[groupIdx]);
        }

        completed++;
        if (completed >= teamsNeedingFetch.length) {
          this.loadingMembers = false;
          // Rebuild individual profile args with full memberships
          if (this.downloadMode === 'individual') {
            this.SelectDownloadType('PDF', this.format);
          }
        }
      });
    });
  }

  private recomputeGroupProfileArgs(team: any, args: any) {
    let cl_l = 0, cl_h = 0, cl_n = 0;
    let id_l = 0, id_h = 0, id_n = 0;
    let de_l = 0, de_h = 0, de_n = 0;
    let im_l = 0, im_h = 0, im_n = 0;
    let integ = 0, hi = 0;

    team.memberships?.forEach(m => {
      const p = m?.default_profile;
      if (!p) return;
      if (p.clarifier_score === 'Low')    { cl_l++; if (cl_l > hi) hi = cl_l; }
      if (p.clarifier_score === 'High')   { cl_h++; if (cl_h > hi) hi = cl_h; }
      if (p.clarifier_score === 'Neutral')  cl_n++;
      if (p.ideator_score === 'Low')      { id_l++; if (id_l > hi) hi = id_l; }
      if (p.ideator_score === 'High')     { id_h++; if (id_h > hi) hi = id_h; }
      if (p.ideator_score === 'Neutral')    id_n++;
      if (p.developer_score === 'Low')    { de_l++; if (de_l > hi) hi = de_l; }
      if (p.developer_score === 'High')   { de_h++; if (de_h > hi) hi = de_h; }
      if (p.developer_score === 'Neutral')  de_n++;
      if (p.implementer_score === 'Low')  { im_l++; if (im_l > hi) hi = im_l; }
      if (p.implementer_score === 'High') { im_h++; if (im_h > hi) hi = im_h; }
      if (p.implementer_score === 'Neutral') im_n++;
      if (p.clarifier_score === 'Neutral' && p.ideator_score === 'Neutral' &&
          p.developer_score === 'Neutral' && p.implementer_score === 'Neutral') integ++;
    });

    args.clarifier_low = cl_l;   args.clarifier_high = cl_h;   args.clarifier_neutral = cl_n;
    args.ideator_low = id_l;     args.ideator_high = id_h;     args.ideator_neutral = id_n;
    args.developer_low = de_l;   args.developer_high = de_h;   args.developer_neutral = de_n;
    args.implementor_low = im_l; args.implementor_high = im_h; args.implementor_neutral = im_n;
    args.integrator = integ;
    args.highest_score = hi;
  }

  public downloadGraph(){
    this.loader = true;
    this.lmbda_service.lambda_invoke('plus-GroupProfileFunction-6y5p4TgXuqZA',this.args)
    this.lmbda_service.lambda_pdf.pipe(takeUntil(this.destroy$)).subscribe((output)=> {
      this.pdfLink = output;
      if(output.length) {
        setTimeout(() => {
          this.loader = false;
        }, 1000);
      }
    })
  }

  private resetSelection() {
    this.content_type = null;
    this.groupProfileType = null;
    this.teamProfileType = null;
    this.pdfLink = null;
    this.individualProfileArgsArr = [];
    this.csvFormat = null;
  }

  public selectCsvFormat(format: 'flat' | 'grouped') {
    this.resetSelection();
    this.downloadMode = null;
    this.csvFormat = format;
  }

  public selectIndividual(format: string) {
    this.resetSelection();
    this.downloadMode = 'individual';
    this.format = format;
    this.content_type = 'PDF';
    // Only build args if members are fully loaded
    if (!this.loadingMembers) {
      this.SelectDownloadType('PDF', format);
    }
  }

  public selectGroup(type: string) {
    this.resetSelection();
    this.downloadMode = 'group';
    this.groupProfileType = type;
  }

  public selectTeamReport() {
    this.resetSelection();
    this.downloadMode = 'teamReport';
    this.teamProfileType = 'pdf';
    // Calculate total member count across selected teams
    this.teamMemberCount = 0;
    this.slectedIndividualTeamArr?.forEach((team) => {
      this.teamMemberCount += team.memberships_count || team.memberships?.length || 0;
    });
  }

  public generatePdf() {
    if (this.loadingMembers) {
      Swal.fire({ title: 'Please Wait', text: 'Team members are still loading. Please try again in a moment.', icon: 'info', confirmButtonColor: '#5cb85c' });
      return;
    }
    if (this.downloadMode === 'individual') {
      // Rebuild args in case members finished loading after format was selected
      if (!this.individualProfileArgsArr?.length) {
        this.SelectDownloadType('PDF', this.format);
      }
      if (!this.individualProfileArgsArr?.length || !this.individualProfileArgsArr[0]?.members?.length) {
        Swal.fire({ title: 'No Team Selected', text: 'Please select a team checkbox first before generating Individual Profiles.', icon: 'warning', confirmButtonColor: '#5cb85c' });
        return;
      }
      this.DownloadThinkingProfile();
    } else if (this.downloadMode === 'group') {
      this.downloadSelectedTeams(this.groupProfileType);
    } else if (this.downloadMode === 'teamReport') {
      this.downloadTeamsReportWithThinkingProifle();
    }
  }

  public closePopup() {
    this.openPdfPopup = false;
    this.openPdfPopupChange.emit(false);
    this.pdfLink = null;
    this.downloadMode = null;
    this.resetSelection();
    // Clear team selections so the next team pick starts fresh
    this.selectedGroupProfileTeamsArr.splice(0);
    this.slectedIndividualTeamArr.splice(0);
    this.mockupReportArgsArr.splice(0);
  }

  public openClosePDFPopup() {
    this.openPdfPopup = !this.openPdfPopup;
    this.openPdfPopupChange.emit(this.openPdfPopup);
    this.downloadMode = null;
    this.resetSelection();
    if (!this.openPdfPopup) {
      // Popup is closing — clear selections so next team pick starts fresh
      this.selectedGroupProfileTeamsArr.splice(0);
      this.slectedIndividualTeamArr.splice(0);
      this.mockupReportArgsArr.splice(0);
    }
    this.fetchMembers();
  }

  // downloading Selected group profile
  public async downloadSelectedTeams(type) {
    if (!this.selectedGroupProfileTeamsArr?.length) {
      Swal.fire({ title: 'No Team Selected', text: 'Please select a team checkbox first before generating a Group Profile.', icon: 'warning', confirmButtonColor: '#5cb85c' });
      return;
    }
    this.loader = true;
    this.loader_text = 'Generating PDF';

    // Merge all selected teams into a single args object
    const first = this.selectedGroupProfileTeamsArr[0];
    const merged = { ...first, content_type: type, downloadAble: false };

    if (this.selectedGroupProfileTeamsArr.length > 1) {
      const scoreKeys = [
        'clarifier_low', 'clarifier_high', 'clarifier_neutral',
        'ideator_low', 'ideator_high', 'ideator_neutral',
        'developer_low', 'developer_high', 'developer_neutral',
        'implementor_low', 'implementor_high', 'implementor_neutral',
        'integrator', 'memberships_count'
      ];
      // Reset then sum across all teams
      scoreKeys.forEach(k => merged[k] = 0);
      this.selectedGroupProfileTeamsArr.forEach(el => {
        scoreKeys.forEach(k => merged[k] += (el[k] || 0));
      });
      // Recalculate highest_score
      const countKeys = [
        'clarifier_low', 'clarifier_high',
        'ideator_low', 'ideator_high',
        'developer_low', 'developer_high',
        'implementor_low', 'implementor_high'
      ];
      merged['highest_score'] = Math.max(...countKeys.map(k => merged[k] || 0));
      // Combine team names
      merged['name'] = this.selectedGroupProfileTeamsArr.map(el => el.name).join(' + ');
    }

    this.http.post(`${environment.profileURL}/api/v1/lambda_functions/invoke.json`, { name: 'plus-GroupProfileFunction-6y5p4TgXuqZA', options: merged }).subscribe((result) => {
      if (result['response'].body) {
        this.loader = false;
        this.pdfLink = result['response'].body;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public async downloadTeamsReportWithThinkingProifle() {
    if (!this.mockupReportArgs && !this.mockupReportArgsArr?.length) {
      Swal.fire({ title: 'No Team Selected', text: 'Please select a team checkbox first before generating a Team Member Report.', icon: 'warning', confirmButtonColor: '#5cb85c' });
      return;
    }
    this.loader = true;
    this.loader_text = 'Generating Report...';

    let args: any;
    if (this.mockupReportArgsArr.length <= 1) {
      args = this.mockupReportArgs;
    } else {
      // Multiple teams: merge member data from all selected teams
      const first = this.mockupReportArgsArr[0];
      args = { ...first };

      // Combine team names
      args.name = this.mockupReportArgsArr.map(a => a.name || a.team_name).join(' + ');
      args.team_name = args.name;

      // Sum total member count
      args.memberships_count = this.mockupReportArgsArr.reduce((sum, a) => sum + (a.memberships_count || 0), 0);

      // Build table_member from raw team data, filling slots across teams up to 20 total.
      // We can't rely on pre-built per-team arrays (each already capped at 20),
      // so we pull directly from slectedIndividualTeamArr memberships.
      const MAX_MEMBERS = 20;
      const combinedTableMember: any[] = [];
      for (const team of this.slectedIndividualTeamArr) {
        if (combinedTableMember.length >= MAX_MEMBERS) break;
        for (const member of (team.memberships || [])) {
          if (combinedTableMember.length >= MAX_MEMBERS) break;
          if (member) {
            combinedTableMember.push({
              name: member.first_name || 'No name',
              last_name: member.last_name || 'No name',
              profile_title: member?.default_profile?.profile_title?.toLowerCase() || '',
              profile_type_id: member?.default_profile?.profile_type_id || null
            });
          }
        }
      }
      args.table_member = combinedTableMember;

      // Combine gppData member-name arrays
      const gppKeys = ['clHigh', 'clLow', 'clNeu', 'idHigh', 'idLow', 'idNeu', 'deHigh', 'deLow', 'deNeu', 'imHigh', 'imLow', 'imNeu'];
      args.gppData = {};
      gppKeys.forEach(k => {
        args.gppData[k] = this.mockupReportArgsArr.flatMap(a => a.gppData?.[k] || []);
      });

      // Sum team_profiles score counts
      const profileKeys = ['clarifier_low', 'clarifier_high', 'clarifier_neutral', 'ideator_low', 'ideator_high', 'ideator_neutral', 'developer_low', 'developer_high', 'developer_neutral', 'implementer_low', 'implementer_high', 'implementer_neutral', 'integrator'];
      args.team_profiles = { ...first.team_profiles };
      profileKeys.forEach(k => {
        args.team_profiles[k] = this.mockupReportArgsArr.reduce((sum, a) => sum + (a.team_profiles?.[k] || 0), 0);
      });
      const countKeys = ['clarifier_low', 'clarifier_high', 'ideator_low', 'ideator_high', 'developer_low', 'developer_high', 'implementer_low', 'implementer_high'];
      args.team_profiles.highest_score = Math.max(...countKeys.map(k => args.team_profiles[k] || 0));
    }

    await this.http.post(`${environment.profileURL}/api/v1/lambda_functions/invoke.json`,{name:"mockup-report-MockupReportFunction-N3eK8yIn2wUf",options:args}).subscribe((result)=> {
        if(result['response'].body) {
          this.loader = false;
          this.pdfLink = result['response'].body;
        }
    })
  }

}
